import { cn } from '@app/utils/cn';
interface Props {
  isDisabled?: boolean;
  bottomContent?: React.ReactNode;
}
export const OrderProductsGroupHeader = ({ isDisabled = false, children, bottomContent }: React.WithChildren<Props>) => {
  return (
    <div className="sticky top-[calc(var(--headerHeight)+var(--breadcrumbsHeight)+0.75rem)] z-topBar mb-2 bg-neutral-96 px-4 py-3 transition-all group-[.scrollingDown]/body:top-[calc(var(--breadcrumbsHeight)+0.75rem)] lg:px-8">
      <div className={cn('grid w-full grid-cols-1 items-center justify-between gap-y-3 sm:flex sm:flex-row', { 'opacity-50': isDisabled })}>
        {children}
      </div>
      {bottomContent}
    </div>
  );
};
